module.exports = __webpack_public_path__ + "static/media/neutral-active.ff82b31d.svg";